import React from 'react';
import { View, StyleSheet, Text, FlatList } from 'react-native';
import OutsidePressHandler from 'react-native-outside-press';

import { scale } from '@components/frame';

import { isPhoneNative, isWeb } from '@helpers';

import { font } from '@styles/fonts';

import Bar from './components/bar';
import Header from './components/header';
import Popup from './components/popup';

import { connect } from 'react-redux';
import { setChartData } from '@reducers/machinesV2';
import { setTimePeriod } from '@reducers/params';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useManageUtilizationChart } from './hooks/useManageUtilizationChart';

const Chart = (props) => {
  const {
    setChartData: setData,
    C,
    selectedDate,
    padding,
    chartWidth,
    getMachineStatsOeeTeepPerPeriod,
    id,
    machineStatistics,
    machineStatisticsLoading,
    machineStatisticsIsError,
  } = props;

  const {
    selectedTime,
    selectedBarIndex,
    setSelectedBarIndex,
    selectedBarItem,
    renderChart,
    selectedIndex,
    toGo,
    saveChartData,
    userStopScroll,
    flatListRef,
    chartHeight,
    rightLegendFontOffset,
    barBlockWidth,
    barWidth,
    barAmount,
    isDay,
  } = useManageUtilizationChart({
    selectedDate,
    chartWidth,
    id,
    setSelectedChartDate: props.setSelectedChartDate,
    resetMobileChartCount: props.resetMobileChartCount,
    setTimePeriod: props.setTimePeriod,
  });

  return (
    <View testID={TEST_IDS.utilizationChart.container} style={{ paddingHorizontal: padding, marginVertical: scale(10) }}>
      {selectedBarIndex !== null && selectedBarItem ? (
        <Popup
          {...{
            C,
            selectedItem: { ...selectedBarItem, height: selectedBarItem.teep * 100 },
            selectedIndex: selectedBarIndex,
            data: { dataBar: renderChart[selectedIndex]?.data?.data || [] },
            fullWidth: chartWidth,
            barBlockWidth,
            id,
            isDay,
            toGo,
          }}
        />
      ) : (
        <Header
          {...{
            item: renderChart[selectedIndex] || {},
            C,
            machineStatistics,
            machineStatisticsLoading,
            machineStatisticsIsError,
            setSelectedChartDate: props.setSelectedChartDateFromCalendar,
            selectedChartDate: selectedDate,
          }}
        />
      )}
      <View
        style={{
          width: '100%',
          marginLeft: scale(15),
        }}
      >
        <View
          testID={TEST_IDS.utilizationChart.chartArea}
          style={{
            height: isWeb ? chartHeight : scale(136),
            width: chartWidth,
          }}
        >
          <View
            style={{
              height: StyleSheet.hairlineWidth,
              width: '100%',
              backgroundColor: C('Hairline/Light/Secondary'),
              position: 'absolute',
              top: 0,
            }}
          />
          <View
            style={{
              height: StyleSheet.hairlineWidth,
              width: '100%',
              backgroundColor: C('Hairline/Light/Secondary'),
              position: 'absolute',
              top: chartHeight,
            }}
          />
          <View
            style={{
              height: StyleSheet.hairlineWidth,
              width: '100%',
              backgroundColor: C('Hairline/Light/Secondary'),
              position: 'absolute',
              top: chartHeight / 2,
            }}
          />
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              alignItems: 'flex-end',
              height: '100%',
            }}
          >
            <View style={{ zIndex: 1000 }}>
              {isWeb ? (
                <OutsidePressHandler
                  onOutsidePress={() => {
                    setSelectedBarIndex(null);
                  }}
                >
                  <Bar
                    {...{
                      item: renderChart[selectedIndex] || {},
                      padding,
                      chartWidth,
                      chartHeight,
                      C,
                      getMachineStatsOeeTeepPerPeriod,
                      id,
                      barBlockWidth,
                      barWidth,
                      barAmount,
                      saveChartData,
                      selectedDate,
                      setChartData: setData,
                      selectedBarIndex,
                      setSelectedBarIndex,
                    }}
                  />
                </OutsidePressHandler>
              ) : (
                <FlatList
                  ref={flatListRef}
                  data={renderChart}
                  renderItem={({ item }) => (
                    <Bar
                      {...{
                        item,
                        padding,
                        chartWidth,
                        chartHeight,
                        C,
                        getMachineStatsOeeTeepPerPeriod,
                        id,
                        barBlockWidth,
                        barWidth,
                        barAmount,
                        saveChartData,
                        selectedDate,
                        selectedBarIndex,
                        setSelectedBarIndex,
                      }}
                    />
                  )}
                  horizontal={true}
                  pagingEnabled={true}
                  initialScrollIndex={selectedIndex}
                  keyExtractor={(item) => item.date}
                  getItemLayout={(_, index) => ({
                    index,
                    length: chartWidth,
                    offset: index * chartWidth,
                  })}
                  maxToRenderPerBatch={2}
                  initialNumToRender={2}
                  windowSize={2}
                  inverted={true}
                  onMomentumScrollEnd={(e) => userStopScroll(e.nativeEvent.contentOffset.x)}
                  showsHorizontalScrollIndicator={false}
                  maintainVisibleContentPosition={{ minIndexForVisible: 0 }}
                />
              )}
            </View>
          </View>
          <View
            testID={TEST_IDS.utilizationChart.rightLegend}
            style={{
              position: 'absolute',
              top: 0,
              right: scale(-40),
              height: '100%',
              width: scale(40),
            }}
          >
            <View style={{ position: 'absolute', top: -rightLegendFontOffset, left: scale(6) }}>
              <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>100%</Text>
            </View>
            <View style={{ position: 'absolute', top: chartHeight / 2 - rightLegendFontOffset, left: scale(6) }}>
              <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>50%</Text>
            </View>
            <View
              style={{
                position: 'absolute',
                bottom: isPhoneNative || !isWeb ? rightLegendFontOffset - 1 : -rightLegendFontOffset,
                left: scale(6),
              }}
            >
              <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>0%</Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default connect(null, { setChartData, setTimePeriod })(Chart);
